import { IconContextButton } from '@monorepo/shared-lib';
import { Divider, Space } from 'antd';
import { ReactComponent as IconClock } from 'assets/images/icons/clockIcon.svg';
import { ReactComponent as IconCheck } from 'assets/images/icons/iconCheck.svg';
import { ReactComponent as IconCross } from 'assets/images/icons/iconCross.svg';
import { ReactComponent as IconPadlock } from 'assets/images/icons/iconPadlock.svg';
import { ReactComponent as IconRevert } from 'assets/images/icons/iconRevert.svg';
import { ReactComponent as IconSave } from 'assets/images/icons/iconSave.svg';
import { StyledTooltip } from 'components/Custom/Tooltip';
import i18n from 'i18next';
import React from 'react';
import { AccountType } from 'store/api/enums';
import { DataLogActions, DataLogStatus } from 'store/app/enums';
import { User } from 'store/auth/models';
import { VatRunData } from 'store/vat/models';
import styled from 'styled-components';
import { checkDisabled } from './check-disabled';
import { getDataLogActionLabel } from 'utils/display-enum-label';

const t = i18n.t.bind(i18n);

const IconWrapper = styled.div`
  width: 25px;
  display: flex;
  justify-content: center;
  //align-items: center;
  height: 25px;
`;
export const getActionMenuItems = (
  vatRunData: VatRunData,
  currentUser: User,
  handleMenuClick: (key: DataLogActions) => void,
  cannotSave?: boolean,
  disableAll?: boolean,
  tooltipText?: string,
  allowActions: DataLogActions[] = []
) => {
  let enabled = false;
  const country = (vatRunData.taxReportCountry ?? '')
    .toString()
    .trim()
    .toLowerCase();
  const isUkReturn =
    country === 'uk' ||
    country === 'united kingdom' ||
    (vatRunData.taxReportTypeName ?? '').toLowerCase().includes('uk');
  const wrap = (node: React.ReactNode, isDisabled: boolean) => {
    return isDisabled ? (
      <StyledTooltip title={tooltipText} placement="top" arrow={false}>
        <span>{node}</span>
      </StyledTooltip>
    ) : (
      <>{node}</>
    );
  };

  return (
    <div className="context-menu-items">
      <Space direction="vertical" style={{ rowGap: '0' }}>
        {vatRunData.dataLogId &&
          ((vatRunData.status &&
            DataLogStatus[vatRunData.status] === DataLogStatus.NOT_SAVED) ||
            !vatRunData.status) && (
            <>
              {(() => {
                const isDisabled =
                  !!disableAll &&
                  !allowActions.includes(DataLogActions.REVERT_DATA);
                return wrap(
                  <IconContextButton
                    type="text"
                    icon={
                      <IconWrapper>
                        <IconRevert style={{ width: 16, height: 16 }} />
                      </IconWrapper>
                    }
                    onClick={() => handleMenuClick(DataLogActions.REVERT_DATA)}
                    disabled={isDisabled}
                  >
                    {getDataLogActionLabel(DataLogActions.REVERT_DATA, t)}
                  </IconContextButton>,
                  isDisabled
                );
              })()}
              {(enabled = true)}
            </>
          )}
        {!checkDisabled(
          DataLogActions.SAVE_VAT_RETURN,
          vatRunData,
          currentUser
        ) && (
          <>
            {(() => {
              const isDisabled =
                !!disableAll &&
                !allowActions.includes(DataLogActions.SAVE_VAT_RETURN);
              return wrap(
                <IconContextButton
                  type="text"
                  icon={
                    <IconWrapper>
                      <IconSave style={{ width: 16, height: 16 }} />
                    </IconWrapper>
                  }
                  onClick={() =>
                    handleMenuClick(DataLogActions.SAVE_VAT_RETURN)
                  }
                  disabled={isDisabled}
                >
                  {getDataLogActionLabel(DataLogActions.SAVE_VAT_RETURN, t)}
                </IconContextButton>,
                isDisabled
              );
            })()}
            {(enabled = true)}
          </>
        )}
        {!checkDisabled(
          DataLogActions.SET_AWAITING_APPROVAL,
          vatRunData,
          currentUser
        ) && (
          <>
            {(() => {
              const isDisabled =
                !!disableAll &&
                !allowActions.includes(DataLogActions.SET_AWAITING_APPROVAL);
              return wrap(
                <IconContextButton
                  type="text"
                  icon={
                    <IconWrapper>
                      <IconClock style={{ width: 16, height: 16 }} />
                    </IconWrapper>
                  }
                  onClick={() =>
                    handleMenuClick(DataLogActions.SET_AWAITING_APPROVAL)
                  }
                  disabled={isDisabled}
                >
                  {getDataLogActionLabel(
                    DataLogActions.SET_AWAITING_APPROVAL,
                    t
                  )}
                </IconContextButton>,
                isDisabled
              );
            })()}
            {(enabled = true)}
          </>
        )}
        {!checkDisabled(
          DataLogActions.SET_INTERNAL_APPROVED,
          vatRunData,
          currentUser
        ) && (
          <>
            {(() => {
              const isDisabled = !allowActions.includes(
                DataLogActions.SET_INTERNAL_APPROVED
              );
              return wrap(
                <IconContextButton
                  type="text"
                  icon={
                    <IconWrapper>
                      <IconCheck
                        style={{ width: 16, height: 16, alignSelf: 'center' }}
                      />
                    </IconWrapper>
                  }
                  onClick={() =>
                    handleMenuClick(DataLogActions.SET_INTERNAL_APPROVED)
                  }
                  disabled={isDisabled}
                >
                  {getDataLogActionLabel(
                    DataLogActions.SET_INTERNAL_APPROVED,
                    t
                  )}
                </IconContextButton>,
                isDisabled
              );
            })()}
            {(enabled = true)}
          </>
        )}
        {!checkDisabled(
          DataLogActions.SEND_FOR_CLIENT_APPROVAL,
          vatRunData,
          currentUser
        ) && (
          <>
            {(() => {
              const isDisabled =
                !!disableAll &&
                !allowActions.includes(DataLogActions.SEND_FOR_CLIENT_APPROVAL);
              return wrap(
                <IconContextButton
                  type="text"
                  icon={
                    <IconWrapper>
                      <IconClock style={{ width: 16, height: 16 }} />
                    </IconWrapper>
                  }
                  onClick={() =>
                    handleMenuClick(DataLogActions.SEND_FOR_CLIENT_APPROVAL)
                  }
                  disabled={isDisabled}
                >
                  {getDataLogActionLabel(
                    DataLogActions.SEND_FOR_CLIENT_APPROVAL,
                    t
                  )}
                </IconContextButton>,
                isDisabled
              );
            })()}
            {(enabled = true)}
          </>
        )}
        {!checkDisabled(
          DataLogActions.SET_NOT_APPROVED,
          vatRunData,
          currentUser
        ) && (
          <>
            {(() => {
              const isDisabled = !allowActions.includes(
                DataLogActions.SET_NOT_APPROVED
              );
              return wrap(
                <IconContextButton
                  type="text"
                  icon={
                    <IconWrapper>
                      <IconCheck
                        style={{ width: 16, height: 16, alignSelf: 'center' }}
                      />
                    </IconWrapper>
                  }
                  onClick={() =>
                    handleMenuClick(DataLogActions.SET_NOT_APPROVED)
                  }
                  disabled={isDisabled}
                >
                  {getDataLogActionLabel(DataLogActions.SET_NOT_APPROVED, t)}
                </IconContextButton>,
                isDisabled
              );
            })()}
            {(enabled = true)}
          </>
        )}
        {!checkDisabled(
          DataLogActions.MARK_AS_SUBMITTED,
          vatRunData,
          currentUser
        ) && (
          <>
            {(() => {
              const isDisabled =
                !!disableAll &&
                !allowActions.includes(DataLogActions.MARK_AS_SUBMITTED);
              return wrap(
                <IconContextButton
                  type="text"
                  icon={
                    <IconWrapper>
                      <IconCheck
                        style={{ width: 16, height: 16, alignSelf: 'center' }}
                      />
                    </IconWrapper>
                  }
                  onClick={() =>
                    handleMenuClick(DataLogActions.MARK_AS_SUBMITTED)
                  }
                  disabled={isDisabled}
                >
                  {isUkReturn
                    ? i18n.t('vat-report.submit-to-hmrc')
                    : getDataLogActionLabel(
                        DataLogActions.MARK_AS_SUBMITTED,
                        t
                      )}
                </IconContextButton>,
                isDisabled
              );
            })()}
            {(enabled = true)}
          </>
        )}
        {enabled && (
          <Divider className="context-menu-items__divider" plain />
        )}
        {!checkDisabled(
          DataLogActions.LOCK_AS_APPROVED,
          vatRunData,
          currentUser
        ) && (
          <>
            {(() => {
              const isDisabled =
                !allowActions.includes(DataLogActions.LOCK_AS_APPROVED) ||
                AccountType[currentUser.accountType] === AccountType.CLIENT;
              return wrap(
                <IconContextButton
                  type="text"
                  icon={
                    <IconWrapper>
                      <IconPadlock style={{ width: 16, height: 16 }} />
                    </IconWrapper>
                  }
                  onClick={() =>
                    handleMenuClick(DataLogActions.LOCK_AS_APPROVED)
                  }
                  disabled={isDisabled}
                >
                  {getDataLogActionLabel(DataLogActions.LOCK_AS_APPROVED, t)}
                </IconContextButton>,
                isDisabled
              );
            })()}
          </>
        )}
        {!checkDisabled(
          DataLogActions.CANCEL_RETURN,
          vatRunData,
          currentUser
        ) && (
          <>
            {(() => {
              const isDisabled =
                !allowActions.includes(DataLogActions.CANCEL_RETURN) ||
                AccountType[currentUser.accountType] === AccountType.CLIENT;
              return wrap(
                <IconContextButton
                  type="text"
                  icon={
                    <IconWrapper>
                      <IconCross
                        style={{ width: 16, height: 16, alignSelf: 'center' }}
                      />
                    </IconWrapper>
                  }
                  onClick={() => handleMenuClick(DataLogActions.CANCEL_RETURN)}
                  disabled={isDisabled}
                >
                  {getDataLogActionLabel(DataLogActions.CANCEL_RETURN, t)}
                </IconContextButton>,
                isDisabled
              );
            })()}
          </>
        )}
      </Space>
    </div>
  );
};
